import { render, staticRenderFns } from "./Table.keyword.vue?vue&type=template&id=0cd3ba49&"
import script from "./Table.keyword.vue?vue&type=script&lang=js&"
export * from "./Table.keyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports